<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" v-if="active">
    <path fill-rule="evenodd"  fill="rgb(65, 56, 135)" d="M29.999,30.999 C29.999,29.343 28.656,27.999 26.999,27.999 C27.388,27.999 22.581,27.999 18.999,27.999 C17.343,27.999 15.999,29.343 15.999,30.999 C15.999,32.602 15.999,41.837 15.999,43.999 C15.999,45.104 15.104,45.999 13.999,45.999 C12.895,45.999 5.104,45.999 3.999,45.999 C2.895,45.999 1.999,45.104 1.999,43.999 C1.999,43.32 1.999,18.999 1.999,18.999 L22.999,0.0 L43.999,18.999 C43.999,18.999 43.999,42.285 43.999,43.999 C43.999,45.104 43.104,45.999 41.999,45.999 C40.895,45.999 33.104,45.999 31.999,45.999 C30.895,45.999 29.999,45.104 29.999,43.999 C29.999,41.751 29.999,32.322 29.999,30.999 Z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" v-else>
    <path fill-rule="evenodd" fill="#333" d="M41.999 45.999h-10a2 2 0 0 1-2-2v-13a3 3 0 0 0-3-3h-8c-1.656 0-3 1.344-3 3v13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-25L22.999 0l21 18.999v25a2 2 0 0 1-2 2zm-1-25.474-18-15.665-18 15.665v21.474a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-12a5 5 0 0 1 5-5h10a5 5 0 0 1 5 5v12a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V20.525z"/>
  </svg>
</template>

<script>
export default {
  props: {
    active: Boolean
  }
}
</script>